import styled from '@emotion/styled';
import Banner from '@shared/components/core/alertNotification/Banner';
import { NotificationListingWrap } from '@shared/components/core/alertNotification/CommonAlertNotificationStyles';
import CurrentUserContainer from '@shared/hooks/state/CurrentUserContainer';
import useFreeTrialStatusBanner from '@shared/hooks/statusBanners/useFreeTrialStatusBanner';

// org specific banner loaders- these do not show across the app, only on org pages
export default function OrganizationBannerLoader() {
    const { upgradeBannersArray } = CurrentUserContainer.useContainer();
    useFreeTrialStatusBanner();

    if (upgradeBannersArray.length === 0) return null;

    return (
        <StyledNotificationListingWrap as="section">
            {upgradeBannersArray.map((banner) => (
                <Banner key={banner.id} {...banner} />
            ))}
        </StyledNotificationListingWrap>
    );
}

const StyledNotificationListingWrap = styled(NotificationListingWrap)`
    margin: 2rem 0;
`;
